import { render } from "./CreateProductItemsFromCategoryModal.vue?vue&type=template&id=4e274082"
import script from "./CreateProductItemsFromCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateProductItemsFromCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__